// extracted by mini-css-extract-plugin
export default {"dropdown-item":"TextDropdownItem_dropdown-item__FrVy7"};